import React from 'react';

import {
    withStyles,
    Grid,
    Typography,
    IconButton,
    ListItem,
    Snackbar,
    Button,
    List,
    ListItemIcon,
    ListItemSecondaryAction,
    Divider,
    ChevronRightOutlinedIcon,
    withRouter
} from '../../material-ui';

import FIMUtils from '../../im/FIMUtils';

import DefaultAvatarImg from '../../images/change/default_avatar.png';

import Apis from '../../network/Apis';
import AppData from '../../model/AppData';
import DeviceEventEmitter, { EventName } from '../../control/event';
import MySnackbarContentWrapper from '../../component/mysnackbar';
import AppUtils from '../../control/apputlis';
import copy from 'copy-to-clipboard';
import MStatusBar from '../view/MStatusBar';
import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter';
import AppConfig from '../../control/config';
import ToName, { JumpPlay, ToLogin } from '../../control/ToName';

const ICON1 = require("../../images/icons/minIcon1.png");
const editeIcon = require("../../images/icons/bianji_icon.png");
const ICON2 = require("../../images/icons/minIcon2.png");
const ICON3 = require("../../images/icons/minIcon3.png");
const ICON4 = require("../../images/icons/zhifu_icon.png");

const subzb = require("../../images/bg/my_subzb.png");

const ICON5 = require("../../images/icons/guanyu_icon@3x.png");
const ICON6 = require("../../images/icons/guanzhu_icon@3x.png");
const ICON7 = require("../../images/icons/lishi_icon@3x.png");

const VipLevelImg = [
    require('../../images/vip/me_vip_level_0.png'),
    require('../../images/vip/me_vip_level_1.png'),
    require('../../images/vip/me_vip_level_2.png'),
    require('../../images/vip/me_vip_level_3.png'),
    require('../../images/vip/me_vip_level_4.png'),
    require('../../images/vip/me_vip_level_5.png'),
]



class MinePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Username: AppData.me.Username,
            Uid: AppData.me.Uid,
            avatar: AppData.me.Pic,
            snackmessage: '',
            snackvariant: 'info',
            newMessage: [],
            level: 0,
            score: 0,
            isShowLabel: false,
            offStore: false
        };

        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 20,
        };
    }

    componentDidMount() {
        DeviceEventEmitter.on(EventName.USER_LOGIN_SUCCESS, this._onLoginSuccess, this);
        DeviceEventEmitter.on(EventName.EVENT_UPDATE_USERINFO, this.updateUserInfo, this);
        IMEventEmitter.on(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        this._getShareConfig();
        AppData.checkUpdate();
        AppUtils.YMPush('MAIN', 'MinePage');


        if (!AppData.me.isLogin() && !AppData.me.isYk && !AppData.me.isYkLogin()) {
            AppData.login();
        }
        if (AppData.ServerConfig.shop_open_status == 2) {
            this.setState({
                offStore: true
            })
        }
        this.getDateDay()

    }

    componentWillUnmount() {
        DeviceEventEmitter.off(EventName.USER_LOGIN_SUCCESS, this._onLoginSuccess, this);
        DeviceEventEmitter.off(EventName.EVENT_UPDATE_USERINFO, this.updateUserInfo, this);
        IMEventEmitter.off(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
    }

    onMessageReceived = (event) => {
        if (event && event.length > 0) {
            this.setState({ showPoint: true, newMessage: event });
        }
    }

    getDateDay = () => {
        let day = AppUtils.getStorageItem('day')
        if (day == null) {
            return
        }

        let date = new Date;
        let d = date.getDay() //今天的日期
        d = d.toString()
        if (d != day) {
            this.setState({
                isShowLabel: true
            })
        }
    }

    getScore = async () => {
        let customer_id = AppData.me.customer_id;
        let token = AppData.me.token;
        let channel = AppConfig.channelid;
        let result = await Apis.encryptionScoreHome(customer_id, token, channel);
        if (result.code == 200) {
            // console.log('积分===>', result.data.score);
            this.setState({
                score: result.data.score
            })
        }
    }

    _getShareConfig = async () => {
        if (AppData.ShareUrl.length > 0) {
            return;
        }
        let result = await Apis.encryptionConfig();
        console.log('encryptionConfig', result);
        if (result.code == 200) {
            AppData.ShareUrl = result.data.download_url;
            AppData.ShareIcon = result.data.share_icon;
            AppData.ShareTittle = result.data.share_title;
            AppData.ShareContent = result.data.share_text;
        }
    }

    _onLoginSuccess = () => {

    }

    updateUserInfo = () => {
        this.setState({
            Username: AppData.me.Username,
            avatar: AppData.me.Pic,
        });
        // this.getVipLevel()
        // this.getScore()


    }



    _onListItemClick = (i) => {
        let { os, token, customerId, channel } = this.props.match.params;

        if (AppData.os !== '') {
            os = AppData.os
        }
        if (i == 0) {
            this.props.history.push('feedback');
        } else if (i == 1) {
            if (copy(AppData.ShareUrl)) {
                this.setState({ snackopened: true, snackmessage: '分享链接已复制' });
            } else {
                this.setState({ snackopened: true, snackmessage: '分享链接复制失败' });
            }
        } else if (i == 2) {
            if (AppData.me.isLogin()) {
                this.props.history.push('/syssetting')
            }
            else {
                ToLogin(this.props, os)
            }
        } else if (i == 3) {
            if (AppData.me.isLogin()) {
                if (AppData.me.token !== '') {
                    token = AppData.me.token
                }
                if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
                    customerId = AppData.me.customer_id
                }
                if (!channel || channel == 0) {
                    channel = AppConfig.channelid;
                }
                ToName(this.props, `/integralwallet/${channel}/${customerId}/${token}/0/?os=${os}`)
            } else {
                ToLogin(this.props, os)
            }
        }
    }

    _onClickMatch = (item) => {
        AppUtils.setStorageItem(AppUtils.SUBSCRIBE_INDEX, 1);
        DeviceEventEmitter.emit(EventName.COMMENT_MAIN_ROUTER_WHERE, 3);
    }

    _onSnackClosed = () => {
        this.setState({ snackopened: false, });
    }

    _onCopyClick = () => {
        this.setState({ snackopened: true, snackmessage: '已复制ID' });
    }

    _onUserClick = () => {
        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        if (AppData.me.isLogin()) {
            let token = 0;
            if (AppData.me.token !== '') {
                token = AppData.me.token
            }

            let customerId = 0
            if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
                customerId = AppData.me.customer_id
            }
            let channel = AppConfig.channelid;
            ToName(this.props, `/viplevel/${channel}/${customerId}/${token}/0`)
        } else {
            ToLogin(this.props, os)
        }
    }

    getVipLevel = async () => {
        if (AppData.me.isLogin()) {
            // this.props.history.push('/setting')

            let customer_id = AppData.me.customer_id;
            let token = AppData.me.token;
            let channel = AppConfig.channelid;

            let result = await Apis.getVipData(customer_id, token, channel);
            console.log("getVipData", result);
            if (result.code == 200) {
                let data = result.data;
                this.setState({
                    level: data.level,
                });
            }

        }
    }

    _onClicAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        JumpPlay(this.props, room_id, match_type, match_id, data);
    }

    onClickSever = () => {
        let nick = '客服';
        let userId = FIMUtils.createChatKey(AppData.serverID);//data.uid; 
        this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: nick });
        // this.props.history.push({ pathname: '/privateletter/' + 10000 + '/userProfile', data: '客服' });
    }


    toHistory = () => {
        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        if (AppData.me.isLogin()) {
            let token = 0;
            if (AppData.me.token !== '') {
                token = AppData.me.token
            }
            let customerId = 0
            if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
                customerId = AppData.me.customer_id
            }
            let uid = AppData.me.Uid
            ToName(this.props, `/history/${os}/${token}/${uid}/0/0/0/0/${customerId}/${AppConfig.channelid}`)
        } else {
            ToLogin(this.props, os)
        }
    }
    toRealname = () => {
        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        if (AppData.me.isLogin()) {
            let token = 0;
            if (AppData.me.token !== '') {
                token = AppData.me.token
            }
            let customerId = 0
            if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
                customerId = AppData.me.customer_id
            }
            let uid = AppData.me.Uid
            ToName(this.props, `/realname/${os}/${token}/${uid}/0/0/0/0/${customerId}/${AppConfig.channelid}`)
        } else {
            ToLogin(this.props, os)
        }
    }

    onZhubo = () => {
        //关注主播
        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        if (AppData.me.isLogin()) {
            let token = 0;
            if (AppData.me.token !== '') {
                token = AppData.me.token
            }
            let customerId = 0
            if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
                customerId = AppData.me.customer_id
            }
            let channel = AppConfig.channelid
            let uid = AppData.me.Uid
            ToName(this.props, `/subscribe/${os}/${token}/${uid}/0/0/0/0/${customerId}/${channel}`)
        } else {
            ToLogin(this.props, os)
        }

    }
    toAbout = () => {
        this.props.history.push('/aboat')
    }
    copyFree_id = () => {
        copy(AppData.me.free_id)
        this.setState({ snackopened: true, snackmessage: '已复制ID' });
    }

    toUserInfo = () => {
        this.props.history.push('/setting')
    }


    render() {
        const { classes } = this.props;
        const { snackopened, snackvariant, snackmessage, offStore, avatar } = this.state;

        let headImg = DefaultAvatarImg
        if (AppData.me.Pic && AppData.me.Pic.length > 0) {
            headImg = AppData.me.Pic;
        }
        if (avatar && avatar.length > 0) {
            headImg = avatar;
        }

        return (
            <React.Fragment>
                <MStatusBar />
                <div className={classes.root} style={{ width: '100%' }}>
                    <Grid container className={classes.infoBox} style={{ width: '100%' }}>
                        {/* <MBackIcon /> */}
                        <Grid className={classes.infoCard} style={{ width: '100%' }}>
                            {/* 编辑按钮 */}
                            {AppData.me.isLogin() &&
                                <img onClick={() => this.toUserInfo()} style={{ position: 'absolute', width: 20, right: 10, top: 15 }} src={editeIcon}>

                                </img>
                            }

                            <div style={{ display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#fff' }}>
                                {/* 用户头像 */}
                                <Grid>
                                    <Button onClick={() => this._onUserClick()} style={{ position: 'relative' }}>
                                        {AppData.me.isLogin() &&
                                            <img className={classes.avatar}
                                                src={headImg}
                                            ></img>
                                        }
                                        {!AppData.me.isLogin() &&
                                            <img className={classes.avatar}
                                                src={headImg}
                                            />
                                        }
                                    </Button>
                                </Grid>
                                {/* 名字部分 */}
                                <Grid container direction='column' style={{ marginLeft: 5, marginTop: 10 }}>
                                    <Grid style={{ display: "flex", alignItems: 'center' }}>
                                        <div onClick={() => this._onUserClick()} style={{ fontSize: 17, color: '#0D0D0D' }}>{AppData.me.isLogin() ? this.state.Username : '点击登录'}</div>
                                        {AppData.me.isLogin() &&
                                            <img className={classes.level} src={VipLevelImg[AppData.me.level]}></img>
                                        }
                                    </Grid>
                                    {AppData.me.isLogin() &&
                                        <Grid style={{ display: 'flex', marginTop: 5, }}>
                                            <span style={{ fontSize: 12, color: '#878787' }}>{'FID: ' + AppData.me.free_id}</span>
                                            {/* <img src={COPY} style={{ height: 15, marginLeft: 10 }} onClick={() => this.copyFree_id()}></img> */}
                                        </Grid>
                                    }
                                    {!AppData.me.isLogin() &&
                                        <Grid style={{ display: 'flex', marginTop: 5 }}>
                                            <span style={{ fontSize: 12, color: '#878787' }}>{'登录后更多福利等你来拿'}</span>
                                        </Grid>
                                    }
                                </Grid>
                            </div>
                            {/* 成为主播 */}
                            <img onClick={() => this.toRealname()} style={{ width: '100%', }} src={subzb}></img>



                        </Grid>

                        <Grid container className={classes.menuBox}>
                            <List style={{ width: '100%' }}>
                                <Grid container direction='column' style={{ width: '100%', backgroundColor: '#FFF', borderRadius: 10, marginBottom: 10 }}>
                                    {
                                        !offStore && <ListItem disableRipple button onClick={() => this._onListItemClick(3)}>
                                            <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                                <Grid container direction='row' alignItems="center">
                                                    <img src={ICON4} alt='' className={classes.menuIcon} style={{ width: 18, height: 18 }} />
                                                    <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>积分商城</Typography>

                                                    {this.state.isShowLabel && <Typography className={classes.signUp}>可签到</Typography>}
                                                </Grid>
                                            </ListItemIcon>
                                            <ListItemSecondaryAction style={{ display: 'flex' }}>
                                                <Typography style={{ color: '#919191', fontSize: 14 }}>{AppData.me.score}</Typography>
                                                <IconButton onClick={() => { this._onListItemClick(3) }} style={{ padding: 0 }} >
                                                    <ChevronRightOutlinedIcon style={{ color: '#919191', fontSize: 20 }} />
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    }

                                </Grid>
                                <Grid container direction='column' style={{ width: '100%', backgroundColor: '#FFF', borderRadius: 10, marginBottom: 10 }}>
                                    {/* onClick={() => this._onListItemClick(0)} */}
                                    <ListItem disableRipple button onClick={() => this.onZhubo()}>
                                        <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <Grid container direction='row' alignItems="center">
                                                <img src={ICON6} alt='' className={classes.menuIcon} style={{ width: 18, height: 18 }} />
                                                <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>关注主播</Typography>
                                            </Grid>
                                        </ListItemIcon>
                                        <ListItemSecondaryAction>
                                            <IconButton onClick={() => { this._onListItemClick(0) }} style={{ padding: 0 }}>
                                                <ChevronRightOutlinedIcon style={{ color: '#919191', fontSize: 20 }} />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <Divider style={{ backgroundColor: '#F2F2F2', marginLeft: 24, marginRight: 24 }} />
                                    <ListItem disableRipple button onClick={() => this.toHistory()}>
                                        <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <Grid container direction='row' alignItems="center">
                                                <img src={ICON5} alt='' className={classes.menuIcon} style={{ width: 18, height: 18 }} />
                                                <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>观看历史</Typography>
                                            </Grid>
                                        </ListItemIcon>
                                        <ListItemSecondaryAction>
                                            <IconButton onClick={() => { this._onListItemClick(1) }} style={{ padding: 0 }} >
                                                <ChevronRightOutlinedIcon style={{ color: '#919191', fontSize: 20 }} />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </Grid>


                                <Grid container direction='column' style={{ width: '100%', backgroundColor: '#FFF', borderRadius: 10 }}>
                                    {/* onClick={() => this._onListItemClick(0)} */}
                                    <ListItem disableRipple button onClick={() => this.onClickSever()}>
                                        <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <Grid container direction='row' alignItems="center">
                                                <img src={ICON1} alt='' className={classes.menuIcon} style={{ width: 18, height: 18 }} />
                                                <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>联系客服</Typography>
                                            </Grid>
                                        </ListItemIcon>
                                        <ListItemSecondaryAction>
                                            <IconButton onClick={() => { this._onListItemClick(0) }} style={{ padding: 0 }}>
                                                <ChevronRightOutlinedIcon style={{ color: '#919191', fontSize: 20 }} />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <Divider style={{ backgroundColor: '#F2F2F2', marginLeft: 24, marginRight: 24 }} />
                                    <ListItem disableRipple button onClick={() => this._onListItemClick(1)}>
                                        <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <Grid container direction='row' alignItems="center">
                                                <img src={ICON3} alt='' className={classes.menuIcon} style={{ width: 18, height: 18 }} />
                                                <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>邀请好友</Typography>
                                            </Grid>
                                        </ListItemIcon>
                                        <ListItemSecondaryAction>
                                            <IconButton onClick={() => { this._onListItemClick(1) }} style={{ padding: 0 }} >
                                                <ChevronRightOutlinedIcon style={{ color: '#919191', fontSize: 20 }} />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <Divider style={{ backgroundColor: '#F2F2F2', marginLeft: 24, marginRight: 24 }} />

                                    <ListItem disableRipple button onClick={() => this.toAbout()}>
                                        <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <Grid container direction='row' alignItems="center">
                                                <img src={ICON7} alt='' className={classes.menuIcon} style={{ width: 18, height: 18 }} />
                                                <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>关于我们</Typography>
                                            </Grid>
                                        </ListItemIcon>
                                        <ListItemSecondaryAction>
                                            <IconButton onClick={() => { this._onListItemClick(1) }} style={{ padding: 0 }} >
                                                <ChevronRightOutlinedIcon style={{ color: '#919191', fontSize: 20 }} />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </Grid>
                                <Grid container direction='column' style={{ width: '100%', backgroundColor: '#FFF', borderRadius: 10, marginTop: 10 }}>
                                    <ListItem disableRipple button onClick={() => this._onListItemClick(2)}>
                                        <ListItemIcon style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <Grid container direction='row' alignItems="center">
                                                <img src={ICON2} alt='' className={classes.menuIcon} style={{ width: 18, height: 18 }} />
                                                <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 15 }}>设置</Typography>
                                            </Grid>
                                        </ListItemIcon>
                                        <ListItemSecondaryAction>
                                            <IconButton onClick={() => { this._onListItemClick(2) }} style={{ padding: 0 }} >
                                                <ChevronRightOutlinedIcon style={{ color: '#919191', fontSize: 20 }} />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </Grid>
                            </List>
                        </Grid>
                    </Grid>
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        open={snackopened}
                        onClose={() => this._onSnackClosed()}
                        autoHideDuration={2000}
                    >
                        <MySnackbarContentWrapper
                            className={classes.snackbar}
                            message={snackmessage}
                            variant={snackvariant}
                        />
                    </Snackbar>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(withStyles((theme) => (
    {
        root: {
            flexGrow: 1,
            backgroundSize: 'cover',
            width: '100vw',
            height: '100vh',
            display: "flex",
            backgroundColor: theme.palette.background.default,
            flexDirection: "column",
            alignItems: 'center',
        },
        level: {
            marginLeft: 5,
            width: 40,
            height: 16,
        },
        infoBox: {
            padding: theme.spacing(0, 0, 0.5),
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',
            width: '100%'
        },
        qinxiTips: {
            backgroundColor: '#f82c5a',
            fontSize: 10,
            color: '#fff',
            position: 'absolute',
            top: 10,
            left: '50%',
            marginLeft: 8,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
            padding: theme.spacing(0, 1, 0, 1),
        },
        copyButton: {
            fontSize: 10,
            color: '#F82A5C',
            backgroundColor: '#FFDCE3',
            padding: theme.spacing(0, 0, 0, 0),
            marginLeft: 10,
            borderRadius: 5,
        },
        header: {
            width: '100%',
            height: 58,
        },
        infoCard: {
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            borderRadius: 0,
            padding: theme.spacing(2, 2, 2, 2),
            borderBottomRightRadius: 10,
            borderBottomLeftRadius: 10,
            alignItems: "center",
            width: '100vm'
        },
        btnCard: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: 0,
            padding: theme.spacing(2, 2, 2, 2),
        },
        tipsContainer: {
            backgroundColor: '#F8E7CC',
            borderRadius: 10,
            color: '#BF9A60',
            marginLeft: 12,
            marginRight: 12,
            height: 35,
        },
        avatar: {
            width: 80,
            height: 80,
            borderRadius: '50%'
            // color: '#fff',
            // backgroundSize: 'cover',
            // backgroundImage: `url(${DefaultAvatarImg})`,

        },
        setBtn: {
            width: 18,
            height: 20,
        },
        signBtn: {
            background: theme.palette.secondary.main,
            borderRadius: 17,
            color: 'white',
            height: 34,
            width: 120,
            fontSize: 14,
            fontWeight: theme.typography.fontWeightBold,
        },
        registerBtn: {
            width: 45,
            height: 45,
        },
        menuBox: {
            width: '100%',
            height: 'auto',
        },
        menuIcon: {
            color: theme.palette.secondary,
            margin: theme.spacing(0.5),
        },
        snackbar: {
            marginTop: '45vh',
        },
        signUp: {
            backgroundColor: '#FF5656',
            borderRadius: 10,
            color: '#FFF',
            fontSize: 10,
            marginLeft: 8,
            padding: theme.spacing(0, 1, 0, 1)
        }
    }
))(MinePage));